import { UserTypeEnum } from "../enums/user-type.enum";

 export class TransactionModel{
    owner_id:number=0;
    amount:number=0;
    description:string='';
    release_date:string='';
    transaction_user_role:any=UserTypeEnum;
  }
